<template>
    <div class="grid" v-if="getMovil() == null || getParada() == null">
		<div class="p-fluid p-formgrid p-grid p-mt-5 p-mb-2">
			<Message severity="error" class="p-col-12">
				Para poder operar en el sistema debe seleccionar el comedor y parada donde está cumpliendo funciones.
			</Message>
		</div>
	</div>
    <div class="grid" v-if="getMovil() != null && getParada() != null">
		<div class="col-12 md:col-6 xl:col-3">
			<div class="card grid-nogutter widget-overview-box widget-overview-box-1">
				<span class="overview-icon">
					<i class="pi pi-qrcode"></i>
				</span>
				<span class="overview-title">Registro de entrega por código QR</span>
				<div class="grid overview-detail">
					<div class="col-12">
						<div class="overview-subtext">Registre aquí todas las entregas realizadas a beneficiaros que presenten código alfanumérico o QR.</div>
					</div>
				</div>
			</div>
		</div>

		<div class="grid p-mt-5">
			<div class="col-12">
				<div class="card">
                    <Toast/>
                    <Message class="p-col-12">
                        Usted está operando en:<br>
                        <i class="pi pi-map"/> {{getMovilName()}}<br>
                        <i class="pi pi-map-marker"/> <i>{{getParadaName()}}</i>
                    </Message>
                    <Message severity="warn" class="p-col-12" v-if="getMultiplicador() != null && getMultiplicador() != 1">
                        El registro de entrega de viandas se realizará en base al <b>factor multiplicador {{getMultiplicador()}}</b>
                    </Message>
                    <div class="p-fluid p-formgrid p-grid p-mt-5 p-mb-2">
                        <div class="p-field p-col-12 p-lg-6">
                            <label for="motivos">Código alfanumérico</label>
                            <div class="p-grid">
                                <div class="p-col-12 p-lg-6 p-mt-3">
                                    <InputText v-model="codigo" :class="{'p-invalid': (submittedCode && !codigo)}" :readonly="false" @keydown="checkKeyDownAlphaNumeric($event)"/>
                                </div>
                                <div class="p-col-12 p-lg-3 p-mt-3">
                                    <Button label="Leer QR" icon="pi pi-qrcode" iconPos="left" class="p-button-outlined p-button-success" @click="openQRReader()"/>
                                </div>
                                <div class="p-col-12 p-lg-3 p-mt-3">
                                    <Button label="Obtener datos" @click="getInfo()" class="p-button-outlined p-button-info" />
                                </div>
                            </div>
                            <small class="p-invalid" v-if="submittedCode && !codigo">Se requiere ingresar un código alfanumérico.</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-6">
                            <Fieldset legend="Información del beneficiario" v-if="data && !beneficiario">
                                <Tag class="mr-2" severity="danger" value="El Código proporcionado es inválido"></Tag>
                            </Fieldset>
                            <Fieldset legend="Información del beneficiario" v-if="data && beneficiario" class="p-shadow-2">
                            <div class="p-grid p-mt-3">
                                <div class="p-col-12 p-md-6">
                                    Nombre:
                                </div>
                                <div class="p-col-12 p-md-6">
                                    {{beneficiario.nombre}}
                                </div>
                            </div>
                            <div class="p-grid p-mt-3">
                                <div class="p-col-12 p-md-6">
                                    Cédula de Identidad:
                                </div>
                                <div class="p-col-12 p-md-6">
                                    {{beneficiario.ci}}
                                </div>
                            </div>
                            <div class="p-grid p-mt-3">
                                <div class="p-col-12 p-md-6">
                                    Fecha nacimiento:
                                </div>
                                <div class="p-col-12 p-md-6">
                                    {{beneficiario.nacimiento}}
                                </div>
                            </div>
                            <div class="p-grid p-mt-3">
                                <div class="p-col-12 p-md-6">
                                    Código:
                                </div>
                                <div class="p-col-12 p-md-6">
                                    {{beneficiario.codigo}}
                                </div>
                            </div>
                            <div class="p-grid p-mt-3">
                                <div class="p-col-12 p-md-6">
                                    Comedor:
                                </div>
                                <div class="p-col-12 p-md-6">
                                    {{beneficiario.comedor}}
                                </div>
                            </div>
                            <div class="p-grid p-mt-3">
                                <div class="p-col-12 p-md-6">
                                    Cantidad de viandas:
                                </div>
                                <div class="p-col-12 p-md-6">
                                    {{getViandas()}}
                                </div>
                            </div>
                            <div class="p-grid p-mt-3">
                                <div class="p-col-12 p-md-6">
                                    Modalidad:
                                </div>
                                <div class="p-col-12 p-md-6">
                                    {{beneficiario.modalidad}}
                                </div>
                            </div>
                            <div class="p-grid p-mt-3">
                                <div class="p-col-12 p-md-6">
                                    Vigencia intervención hasta:
                                </div>
                                <div class="p-col-12 p-md-6">
                                    <Tag class="mr-2" :value="beneficiario.vencimiento" rounded icon="pi pi-calendar"></Tag>
                                </div>
                            </div>
                            <div class="p-grid p-mt-3">
                                <div class="p-col-12 p-md-6">
                                    Viandas a entregar:
                                </div>
                                <div class="p-col-12 p-md-6">
                                    <Badge :value="getViandasEntregar()" severity="success" size="large"></Badge>
                                </div>
                            </div>
                            <div class="p-grid p-mt-3">
                                <div class="p-col-12 p-md-6">
                                    Distribución a entregar:
                                </div>
                                <div class="p-col-12 p-md-6">
                                    {{beneficiario.distribucion}}
                                </div>
                            </div>
                            <div class="p-grid p-mt-3">
                                <div class="p-col-12 p-md-6">
                                    Vigencia QR hasta:
                                </div>
                                <div class="p-col-12 p-md-6">
                                    <Tag class="mr-2" :value="beneficiario.vigencia" rounded icon="pi pi-qrcode"></Tag>
                                </div>
                            </div>
                            <div class="p-grid p-mt-3">
                                <div class="p-col-12 p-md-6">
                                    Último retiro efectuado:
                                </div>
                                <div class="p-col-12 p-md-6">
                                    <Tag class="mr-2" :value="beneficiario.ultimo" rounded icon="pi pi-qrcode"></Tag>
                                </div>
                            </div>
                        </Fieldset>
                        </div>
                    </div>
                    <Toolbar>
                        <template v-slot:left>
                            <Button label="Limpiar" @click="clearAll()" icon="pi pi-eraser" class="p-button-secondary" iconPos="left"/>
                        </template>

                        <template v-slot:right>
                            <Button label="Entregar" @click="entregar()" icon="pi pi-angle-right" iconPos="left" :loading="loading"/>
                        </template>
                    </Toolbar>
				</div> 
			</div>
		</div>
	</div>	

	<Dialog header="Aguarde..." v-model:visible="wait" :style="{width: '150px'}" :modal="true" :position="left">
		<div align="center">
			<ProgressSpinner style="width:50px;height:50px" strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"/>
		</div>
	</Dialog>

    <Dialog header="Leer QR" :visible="displayQRReader" :breakpoints="{'960px': '75vw', '640px': '90vw'}" :style="{width: '50vw'}" :modal="true" :closable="true" :closeOnEscape="true" @update:visible="hideHandler">
        <StreamBarcodeReader @decode="(a,b,c)=> onDecode(a,b,c)" @loaded="()=>onLoaded()" style="width:75%; margin:auto;"></StreamBarcodeReader>
    </Dialog>
	
</template>

<script>
import SmartService from '../service/SmartService';
import {StreamBarcodeReader} from "vue-barcode-reader";
export default {
    name: "ScanBarcode",
	data() {
		return {
			wait: false,
            loading: false,
            codigo: "",
            submittedCode: false,
            beneficiario: {},
            data: false,
            displayQRReader:false,
            ignoredValue: "",
		}
	},	
	smartService: null,
	created() {
		this.smartService = new SmartService();
	},
	mounted() {

	},
	methods: {
        checkKeyDownAlphaNumeric(event) {
            if (!/[a-zA-Z0-9\s]/.test(event.key)) {
                this.ignoredValue = event.key ? event.key : "";
                event.preventDefault();
            }
        },
        getMovil(){
            return localStorage.movil_id;
        },

        getParada(){
            return localStorage.parada_id;
        },

        getMovilName(){
            return localStorage.movil_name;
        },

        getParadaName(){
            return localStorage.parada_name;
        },

        getIdTec(){
            return localStorage.tec_id;
        },

        getViandas(){
            return this.beneficiario.viandas;
        },

        getViandasEntregar(){
            return (this.beneficiario.viandas * Number(localStorage.multiplicador));
        },

        getMultiplicador(){
            return localStorage.multiplicador;
        },

        entregar(){
            this.registrarCodigo();
        },

        clearAll(){
            this.submittedCode = false;
            this.data = false;
            this.beneficiario = null;
            this.codigo = null;
        },

        openQRReader(){
            this.clearAll();
            this.displayQRReader = true;
        },

        closeQRReader() {
            this.displayQRReader = false;
        },

        hideHandler(value) { 
            if (!value)
                this.displayQRReader = false; 
        },

        scanBarcode() {
            console.log("scanning...");
        },

        onDecode(a,b,c) {
            console.log("Código leído: " + a,b,c);
            this.codigo = a;
            this.closeQRReader();
            /* if (this.id) clearTimeout(this.id);
            this.id = setTimeout(() => {
                if (this.codigo === a) {
                    this.codigo = "";
                }
                }, 
            5000); */
            this.getInfo();
        },

        onLoaded() {
        console.log('Listo para comenzar a escanear...')
        },

        async getInfo(){
            this.data = false;
            this.beneficiario = {};
            this.submittedCode = true;
            //hay un código leído o ingresado manual
            if (this.codigo && this.codigo.length == 6){
                this.wait= true;
                this.smartService.obtenerDatosQR(this.codigo, Number(this.getMultiplicador()), Number(this.getMovil())).then(data => {        	
                    if(data.fNac) {
                        this.beneficiario.ci = data.ci;
                        this.beneficiario.nombre = data.name;
                        this.beneficiario.nacimiento = data.fNac;
                        this.beneficiario.viandas = data.cantViandas;
                        this.beneficiario.vigencia = data.fVencimiento;
                        this.beneficiario.ultimo = data.ultimoRetiro;
                        this.beneficiario.codigo = this.codigo;
                        this.beneficiario.comedor = data.comedorOrigen;
                        this.beneficiario.modalidad = data.modalidad;
                        this.beneficiario.vencimiento = data.fechaVencInt;
                        this.beneficiario.distribucion = data.distribucionDieta;
                        this.data = true;
                    } else {
                        this.data = false;
                        if (data.includes("ERROR")){
                            let aux = data.split("ERROR").pop();
                            let msg = aux.replace("ERROR","");
                            this.$toast.add({severity:'error', summary: 'Error', detail: msg, life: 3000});
                        }
                        else if (data.includes("WARN")){
                            let aux = data.split("WARN").pop();
                            let msg = aux.replace("WARN","");
                            this.$toast.add({severity:'warn', summary: 'Atención', detail: msg, life: 3000});
                        }
                        else if (data.includes("denied") || data.includes("denegado")){
                            this.$toast.add({severity:'error', summary: 'Error en la obtención de datos QR', detail: 'Ha ocurrido un error al comunicarse con el servidor. Cierre sesión, vuelva a ingresar e intentelo nuevamente.', life: 5000});
                        }
                        else{
                            let msg = data;
                            this.$toast.add({severity:'error', summary: 'Error', detail: msg, life: 3000});    
                        }
                    }
                    this.wait=false;
                })
                .catch((e) => {
                    console.log(e);
                    this.wait=false;            	
                    this.$toast.add({severity:'error', summary: 'Error en la obtención de datos QR', detail: 'Ha ocurrido un error al comunicarse con el servidor', life: 3000});
                });
            }
            else{
                if (this.codigo && this.codigo.length != 6){
                    this.$toast.add({severity:'error', summary: 'Error', detail: 'La estructura del código es incorrecta', life: 3000});
                }
            }
        },

        async registrarCodigo() {
            this.submittedCode = true;
            //hay un código leído o ingresado manual
            if (this.codigo && this.codigo.length == 6){
                //Si no obtuvo datos se le pide que lo haga y verifique la información
                if (this.data == false){
                    this.$toast.add({severity:'warn', summary: 'Verifique la información', detail: 'Antes de efectuar la entrega presione obtener datos y verifique la información del beneficiario.', life: 5000});
                }
                else{
                    //Si hay datos en pantalla pero son para un código disinto al ingresado se le pide que actualice los datos y verifique la información
                    if (this.data == true && this.beneficiario && this.codigo && (this.beneficiario.codigo != this.codigo)){
                        this.$toast.add({severity:'warn', summary: 'Actualice la información', detail: 'La información en pantalla no corresponde al código ingresado. Presione obtener datos, actualice y verifique la información.', life: 5000});
                    }
                    //Si está todo ok se procede a intentar el envío
                    else{
                        this.wait= true;
                        this.loading = true;
                        this.smartService.registrarRetiroQR(this.codigo, Number(this.getMovil()),Number(this.getParada()),Number(this.getIdTec()), Number(this.getMultiplicador())).then(data => {
                            let msg = data;
                            this.wait= false;
                            this.loading = false;
                            if (msg != null){
                                if (msg.includes("ERROR")){
                                    msg = msg.replace("ERROR","");
                                    this.$toast.add({severity:'error', summary: 'Error', detail: msg, life: 3000});
                                }
                                else if (msg.includes("WARN")){
                                    msg = msg.replace("WARN","");
                                    this.$toast.add({severity:'warn', summary: 'Atención', detail: msg, life: 3000});
                                }
                                else{
                                    this.$toast.add({severity:'success', summary: 'Registro exitoso', detail:msg, life: 3000});    
                                }
                            }
                            else{
                                this.$toast.add({severity:'error', summary: 'La entrega no fue registrada', detail: 'Ha ocurrido un error al comunicarse con el servidor. Cierre sesión, vuelva a ingresar e intentelo nuevamente.', life: 5000});
                            }
                        });
                    }
                }
            }
            else{
                if (this.codigo && this.codigo.length != 6){
                    this.$toast.add({severity:'error', summary: 'Error', detail: 'La estructura del código es incorrecta', life: 3000});
                }
            }
		},

	},
    components: {
    StreamBarcodeReader,
    },
}
</script>

<style scoped lang="scss">
	.overview-detail {
        text-align: left;
        margin-top: 2rem;

        .p-col-6 {
            padding: .5rem;
        }
    }
</style>